const moment = require('moment-timezone');

export default {
    formatAccountName(network, accountName, accountScreenName) {
        return (network === 'twitter') ?
            '@' + accountScreenName : accountName;
    },
    formatDate(dateToFormat, timeZone) {
        return moment.utc(dateToFormat).tz(timeZone).format('MMM D, Y [at] h:mmA');
    },
    linkToPost(network, accountName, postEntityId) {
        if (!network) return '';
        let linkToPost = '';
        network = network.toLowerCase();
        if (network === 'facebook') {
            linkToPost = 'https://www.facebook.com/' + postEntityId;
        } else if (network === 'twitter') {
            linkToPost = 'https://twitter.com/' + accountName + '/status/' + postEntityId;
        }
        return linkToPost;
    },
    linkToProfile(network, accountName, accountId) {
        if (!network) return '';
        let linkToProfile = '';
        network = network.toLowerCase();
        if (network === 'facebook') {
            linkToProfile = 'https://www.facebook.com/' + accountId;
        } else if (network === 'twitter') {
            linkToProfile = 'https://twitter.com/' + accountName;
        }
        return linkToProfile;
    }
};